import { useAppSelector } from 'redux-state/configure-store.js';
import { createFavouriteApi } from 'redux-state/favourites/types.js';
import { IRepoState } from 'redux-state/rootReducer.js';
import { FavouriteCurrentLocationHook } from './location-favourite-properties.js';

/** Identifies if page has favourite properties and if it is currently in favs list */
export const UsePageFavouriteProps = () => {
  const location = useAppSelector((state: IRepoState) => state.LAYOUT.screen?.location);
  const allFavouritedItems = useAppSelector((s) => s.FAVOURITES.allItems);
  const searchLabel = useAppSelector((s: IRepoState) => s.LAYOUT.screen?.searchLabel);
  const { type, key, favouriteKey, favouriteType } = FavouriteCurrentLocationHook({ location });
  if (type && key) {
    const locationKey = createFavouriteApi({ type, key, favouriteKey, favouriteType });
    const isPageFavourited = allFavouritedItems.find((fav) => {
      return createFavouriteApi(fav) === locationKey;
    });
    // Page cannot be favourited as the data in json in not available
    const displayFavouriteIcon = !!searchLabel && !!location;

    return { displayFavouriteIcon, isPageFavourited: !!isPageFavourited };
  }

  return { displayFavouriteIcon: false, isPageFavourited: false };
};
